<style >
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.activeClass{
  background: #fff!important;
}
</style>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Satış Raporları",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader
  },
  data() {
    return {
        details:[],
        search: true,
        title: "SATIŞ RAPORLARI",
        items: [
        {
          text: "ANASAYFA",
          href: "/",
        },
        {
          text: "SATIŞ RAPORLARI",
          active: true,
        },
      ],
      info:{},
      isLoading: false,
      detailSearch:false,
      form:{},
      list:{
        groups:[],
        dealers:[],
        tariffs:[],
        payTypes:[]
      },
      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {
        },
        sort: [
          {
            field: '',
            type: '',
          },
        ],
        page: 1,
        perPage: 50,
      },
      currentPage: 0,
      selected: 0,
      pageLength: 0,
        url: "reports/sales",
        paginationOptions: {
        enabled: true,
        dropdownAllowAll: false,
        perPage: 50,
        setCurrentPage: 1,
        perPageDropdown: [50, 100, 200],
        nextLabel: 'Sonraki',
        prevLabel: 'Önceki',
        rowsPerPageLabel: 'Kayıt Göster',
        ofLabel: 'of',
        pageLabel: 'sayfa', // for 'pages' mode
        infoFn: params => `${params.firstRecordOnPage} - ${params.lastRecordOnPage} ( Toplam: ${params.totalRecords}) `,
      },
      openRightDrawer: false,
      selectOptions: {
        enabled: false,
        selectOnCheckboxOnly: true,
        selectionInfoClass: 'custom-class',
        selectionText: 'adet kayıt seçildi',
        clearSelectionText: 'seçimi iptal et',
        disableSelectInfo: false,
        selectAllByGroup: false,
      },
     columns: [
        {
          label: 'Fatura Tarihi',
          field: 'date',
          sortable: false,
        },
        {
          label: 'Abonelik',
          field: 'username',
          sortable: false,
        },
         {
          label: 'Ödeme Tarihi',
          field: 'paiddate',
          sortable: false,
        },
        {
          label: 'Toplam',
          field: 'amount',
          sortable: false,
        },
        {
          label: 'Ödemeyi Alan',
          field: 'createdname',
          sortable: false,
        },
        {
          label: 'Bayi',
          field: 'name',
          sortable: false,
        },
        {
          field: '#',
          sortable: false,
          thClass: 'width-50',
        },
      ],
    };
  },
   mounted() {
    this.loadItems()
    this.$http.get('/group/search')
    .then(resp => {
        this.list.groups = resp.data.content
    })
    .catch(error => error)
    this.$http.get('/dealers/search')
    .then(resp => {
        this.list.dealers = resp.data.content
    })
    .catch(error => error)
    this.$http.post('/accounting/safebank', {output:'only'})
    .then(resp => {
        this.list.payTypes = resp.data
    })
    .catch(error => error)
  },
  methods: {
      updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    loadItems() {
      this.getFromServer(this.serverParams).then(response => {
        this.totalRecords = response.totalRecords
        this.pageLength = response.pageLength
        this.currentPage = response.currentPage
        this.rows = response.rows
        this.info = response.info
      
      })
    },
    getFromServer() {
      return new Promise((resolve, reject) => {
        this.$http.post(this.url, this.serverParams)
          .then(res => {
            resolve({
              rows: res.data.content.data,
              info: res.data.info,
              totalRecords: res.data.content.total,
              pageLength: res.data.content.last_page,
              currentPage: res.data.content.current_page,
            })
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    formSubmit(){
      this.updateParams({columnFilters : {...this.form}});
      this.loadItems()
    },
     tariff(a){
        this.$http.post('/tariff/getByGroup', { groupName : a.target.value ,output:'only'})
        .then(resp => {
            this.list.tariffs = resp.data.content
        })
        .catch(error => error)
    },
    allClear(){
      this.form = {}
    },
    excelExport() {
      this.$http.post('/reports/export/sales',  {...this.form})
      .then((response) => {
          var temp = 'data:application/vnd.ms-excel;base64,'
              +encodeURIComponent(response.data.content);  
          var download = document.createElement('a');  
          download.href = temp;  
          download.download = response.data.filename;  
          document.body.appendChild(download);  
          download.click();
          document.body.removeChild(download);
      });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

     <div class="row mb-3">
        <div class="col-md-6 offset-lg-6 text-end">
           <div class="button-items mx-2">
              <button 
                class="btn btn-outline-success" 
                type="button"  
                @click="excelExport()">
                    Excel'e Al
              </button>
             <button 
                class="btn btn-outline-light bg-light" 
                :class="{ activeClass: detailSearch }"
                type="button"  
                @click="detailSearch = !detailSearch">
                <i class="bx bx-filter-alt"></i> Detaylı Arama
            </button>
          </div>
      </div>
     <Transition  name="fade" v-if="detailSearch">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <form class="needs-validation" @submit.prevent="formSubmit">
                <div class="row">
                  <div class="col-xl-3">
                    <div class="mb-3">
                       <label >Hizmet Türü</label>
                        <select 
                          v-model="form.tarife_turu" 
                          class="form-control form-select" 
                          @change="tariff($event)"
                        >
                          <option value="">Seçiniz</option>
                          <option value="ADSL">ADSL</option>
                          <option value="XDSL">VDSL</option>
                          <option value="FIBER">Fiber</option>
                          <option value="HIPER">Hiper</option>
                          <option value="METRO">Metro</option>
                          <option value="WIFI">WiFi</option>	
                      </select>
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="mb-3">
                      <label>Tarife Türleri</label>
                      <v-select
                              label="name" 
                              v-model="form.tariff"
                              :options="list.tariffs" 
                              :reduce="df => df.id">
                        <span slot="no-options">Sonuç Bulunamadı</span>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="mb-3">
                      <div class="mb-3">
                      <label>Müşteri Grubu</label>
                        <v-select
                              label="name" 
                              v-model="form.group"
                              :options="list.groups" 
                              :reduce="df => df.id">
                        <span slot="no-options">Sonuç Bulunamadı</span>
                    </v-select>
                    </div>
                  </div>
                </div>
                <div class="col-xl-3">
                  <div class="mb-3">
                      <div class="mb-3">
                      <label>Müşterinin Ait Olduğu Bayi</label>
                        <v-select
                              label="name" 
                              v-model="form.dealer"
                              :options="list.dealers" 
                              :reduce="df => df.id">
                        <span slot="no-options">Sonuç Bulunamadı</span>
                      </v-select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                  <div class="col-xl-3">
                    <div class="mb-3">
                      <label>Ödeme Türü</label>
                      <v-select
                              label="title" 
                              v-model="form.payType"
                              :options="list.payTypes" 
                              :reduce="df => df.id">
                        <span slot="no-options">Sonuç Bulunamadı</span>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="row">
                        <div class="col-md-12">
                          <div class="mb-3">
                            <label class="d-flex justify-content-between">Ödemenin Yapıldığı Tarih 
                              <span 
                                v-if="form.startdate || form.startdateend" 
                                class="text-danger" 
                                @click="form.startdate= '' ;form.startdateend= ''">
                                temizle</span></label>
                            <div class="input-group">
                              <input type="date" class="form-control"  v-model="form['startdate']">
                              <button style="border:0;background: transparent;">  - </button>
                              <input type="date" class="form-control"  v-model="form['startdateend']">
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>
                  
                </div>
                <div class="row">
                  <div class="col-md-4 offset-md-8 text-end">
                    <div class="button-items">
                       <button 
                          type="submit"
                          class="btn btn-outline-danger"  
                          @click="allClear()" 
                          >
                          Sorguyu Temizle
                        </button>
                        <button 
                          type="submit"
                          class="btn btn-primary"   
                          >
                           Sorgula
                        </button>
                    </div>
                  </div>
                </div>    
              </form>
              <!-- end card -->
          </div>
        </div>
      </div>
    </Transition>
      <!-- end col -->
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
             <vue-good-table
                mode="remote"
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                :search-options="{enabled: false}"
                :select-options="selectOptions"
                :pagination-options="paginationOptions"
                :is-loading.sync="isLoading"
                @on-page-change="onPageChange"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                  <div>Yükleniyor</div>
                </template>
                <div slot="table-actions" class="px-3" v-if="info">
                  Toplam <b>{{ info.count }}</b> Adet <b>{{ info.total }}</b> TL Satış
                </div>
                <template
                  slot="table-row"
                  slot-scope="props"
                >
                  <span
                    v-if="props.column.field === '#'"
                    class="text-nowrap"
                  >
                     <ul class="list-inline font-size-20 contact-links mb-0">
                        <li class="list-inline-item px-1">
                          <a v-b-tooltip.hover title="İndir">
                            <i class="mdi mdi-download-outline"></i>
                          </a>
                        </li>
                      </ul>
                  </span>
                </template>
            </vue-good-table>
        </div>
      </div>
    </div>
  </Layout>
</template>